/**
 * Truncates a string to a specified maximum length and appends an ellipsis ("...") if the string exceeds that length.
 *
 * @param str - The input string to be truncated.
 * @param maxLength - The maximum allowed length of the string before truncation. Defaults to 100.
 * @returns The original string if its length is less than or equal to `maxLength`, otherwise a truncated string with an appended ellipsis.
 */
export const ellipseText = (str: string, maxLength: number = 100): string => {
  if (!str) {
    return '';
  }

  if (str.length <= maxLength) {
    return str;
  }

  return str.slice(0, maxLength) + '...';
};
